import styled from 'styled-components';
import DetailsComponent from '../Details/DetailsComponent';

const ErrorComponent = () => {
  return (
    <DetailsComponent>
      <Wrapper>
        <SideBar></SideBar>
        <ErrorWrapper>
          <Header>This page was lost</Header>
          <ErrorMessage>
            The page you're looking for isn't available. Try to search again.
          </ErrorMessage>
        </ErrorWrapper>
        <SideBar></SideBar>
      </Wrapper>
    </DetailsComponent>
  );
};

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

const SideBar = styled.div`
  flex: 1;
`;

const ErrorWrapper = styled.div`
  background-color: ${({ theme }) => theme.tileBackground};
  height: fit-content;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px;
  @media (max-width: 500px) {
    gap: 8px;
    padding: 16px;
  }
`;

const Header = styled.h1`
  font-size: 4rem;
  @media (max-width: 500px) {
    font-size: 1.7rem;
  }
`;

const ErrorMessage = styled.p`
  font-size: 1.5rem;
  @media (max-width: 500px) {
    font-size: 1rem;
  }
`;

export default ErrorComponent;
